import { type RoboticsModule, type RoboticsNavItem } from "./types";

interface RoboticsViewProps {
  module: RoboticsModule;
  /** Active view key (matches a `module.tabs[].value`). */
  view: string;
}

/**
 * Mounts a single robotics view (Dashboard / Maintenance / Units …). This is
 * what the host (UnitLogic) renders in its content area; the host owns the
 * navigation and passes the active `view`. Fills its container — host it in a
 * bounded, flex-column box.
 */
export function RoboticsView({ module, view }: RoboticsViewProps) {
  const tab = module.tabs.find((t) => t.value === view) ?? module.tabs[0];
  if (!tab) return null;
  const Component = tab.Component;
  return (
    <div
      style={
        tab.fill
          ? { flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }
          : { flex: 1, minHeight: 0, overflowY: "auto" }
      }
    >
      <Component />
    </div>
  );
}

/**
 * The navigation manifest for a module — label/icon/value per view, without the
 * content component. The host renders these as sidebar links.
 */
export function getRoboticsNavItems(module: RoboticsModule): RoboticsNavItem[] {
  return module.tabs.map(({ value, label, icon }) => ({ value, label, icon }));
}
